export default __webpack_public_path__ + "static/media/Think_tank_c.e43c0113.svg";